export const readableContact = (v: string) => {
  return v.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
}

export const readableFileSize = (bytes: number) => {
  const thresh = 1024
  const dp = 1

  if (Math.abs(bytes) < thresh) {
    return bytes + " B"
  }

  const units = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
  let u = -1
  const r = 10 ** dp

  do {
    bytes /= thresh
    ++u
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  )

  return bytes.toFixed(dp) + " " + units[u]
}

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const mimeTypeToExtension = (mimeType: string): string => {
  const mimeToExtMap: { [key: string]: string } = {
    "application/pdf": "pdf",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      "docx",
    "application/docxconverter": "docx",
    "application/haansoftdocx": "docx",
    "application/x-hwp": "hwp",
    "application/hwp": "hwp",
    "application/haansofthwp": "hwp",
    "application/vnd.hancom.hwp": "hwp",
    "application/haansofthwpx": "hwpx",
    "application/vnd.ms-excel": "xls",
    "application/vnd.ms-powerpoint": "ppt",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      "pptx",
  }

  return mimeToExtMap[mimeType]
}
